import { platformAndroid, platformIos, platformWeb } from './platform';
import { Network } from '@capacitor/network';
import { storageGetAuth } from './storage';

export const returnToMainLogout = (router: any) => {
  if (platformWeb()) {
    router.replace('/');
    window.location.reload();
  } else {
    sendCommandToApp(buildCommand({ command: 'accountTerminated' }));
  }
};

export const virtualCardCreated = () => {
  if (!platformWeb()) {
    sendCommandToApp(buildCommand({ command: 'virtualCardCreated' }));
  }
};

export const backCompleted = () => {
  sendCommandToApp(buildCommand({ command: 'ionicGoBackProcessed' }));
};

export const returnToMain = (router: any) => {
  return new Promise<void>((resolve) => {
    if (platformWeb()) {
      router.replace('/home');
    } else {
      sendCommandToApp(buildCommand({ command: 'closeScreen' }));
    }
    resolve();
  });
};

export const returnToSignin = (router?: any) => {
  if (platformWeb()) {
    router && router.replace('/home');
    !router && window.location.replace('/home');
  } else {
    sendCommandToApp(
      buildCommand({ command: 'closeScreen', destination: 'signIn' }),
    );
  }
};

export const refreshToken = () => {
  if (!platformWeb()) {
    sendCommandToApp(buildCommand({ command: 'refreshToken' }));
  } else {
    const tokens = storageGetAuth();
    window.postMessage(
      'auth=' + tokens?.access_token + ';' + tokens?.refresh_token,
      '*',
    );
    console.log('Refresh token called in web environment');
  }
};

const buildCommand = (cmd: any) => {
  return JSON.stringify(cmd);
};

declare const window: any;
declare const AndroidNativeHandler: any;
const sendCommandToApp = (command: string) => {
  if (platformIos()) {
    console.log('Calling ios command', command);
    window.webkit.messageHandlers.nativeHandler.postMessage(command);
  } else if (platformAndroid()) {
    console.log('Calling android command', command);
    //Android.nativeHandler.nativeMethodCalled(command);
    try {
      AndroidNativeHandler.nativeMethodCalled(command);
    } catch (e) {
      console.warn("No native handler found. Command: " + command + "")
    }
  } else if (platformWeb()) {
    console.log('Not calling command in web', command);
  } else {
    console.log('Unknwon command environment', command);
  }
};

export const appIsOnline = async () => {
  return true;
  if (platformWeb()) {
    if (navigator.onLine) {
      return true;
    } else {
      return false;
    }
  } else {
    const status = await Network.getStatus();
    if (status.connected) {
      return true;
    } else {
      return false;
    }
  }
};
